import { createContext, useContext, useState } from "react";
import axios from "axios";
// import { io } from "socket.io-client";

const SecurityMasterContext = createContext();
const NIFTY_50 = [
  "TITAN",
  "WIPRO",
  "HCLTECH",
  "INFY",
  "JIOFIN",
  "TECHM",
  "TCS",
  "APOLLOHOSP",
  "BAJAJ-AUTO",
  "SUNPHARMA",
  "COALINDIA",
  "ICICIBANK",
  "JSWSTEEL",
  "EICHERMOT",
  "BEL",
  "ADANIENT",
  "ETERNAL",
  "TRENT",
  "LT",
  "TATACONSUM",
  "AXISBANK",
  "KOTAKBANK",
  "ULTRACEMCO",
  "NESTLEIND",
  "RELIANCE",
  "ITC",
  "NTPC",
  "HINDALCO",
  "ADANIPORTS",
  "BAJAJFINSV",
  "SHRIRAMFIN",
  "HDFCLIFE",
  "BAJFINANCE",
  "BHARTIARTL",
  "HINDUNILVR",
  "M&M",
  "GRASIM",
  "INDIGO",
  "ONGC",
  "SBIN",
  "DRREDDY",
  "SBILIFE",
  "TATASTEEL",
  "HDFCBANK",
  "ASIANPAINT",
  "MAXHEALTH",
  "TMPV",
  "POWERGRID",
  "MARUTI",
  "CIPLA",
];
const NIFTY_100 = [
  "ADANIENT",
  "ADANIPORTS",
  "APOLLOHOSP",
  "ASIANPAINT",
  "AXISBANK",
  "BAJAJ-AUTO",
  "BAJFINANCE",
  "BAJAJFINSV",
  "BHARTIARTL",
  "BPCL",
  "BRITANNIA",
  "CIPLA",
  "COALINDIA",
  "DIVISLAB",
  "DRREDDY",
  "EICHERMOT",
  "GRASIM",
  "HCLTECH",
  "HDFCBANK",
  "HDFCLIFE",
  "HEROMOTOCO",
  "HINDALCO",
  "HINDUNILVR",
  "ICICIBANK",
  "INDUSINDBK",
  "INFY",
  "ITC",
  "JSWSTEEL",
  "KOTAKBANK",
  "LT",
  "LTIM",
  "M&M",
  "MARUTI",
  "NESTLEIND",
  "NTPC",
  "ONGC",
  "POWERGRID",
  "RELIANCE",
  "SBILIFE",
  "SBIN",
  "SUNPHARMA",
  "TATACONSUM",
  "TATAMOTORS",
  "TATASTEEL",
  "TCS",
  "TECHM",
  "TITAN",
  "ULTRACEMCO",
  "UPL",
  "WIPRO",

  "ABB",
  "ADANIGREEN",
  "ADANITRANS",
  "AMBUJACEM",
  "AUROPHARMA",
  "BANDHANBNK",
  "BANKBARODA",
  "BERGEPAINT",
  "BIOCON",
  "BOSCHLTD",
  "CANBK",
  "CHOLAFIN",
  "COLPAL",
  "CONCOR",
  "DABUR",
  "DLF",
  "GAIL",
  "GODREJCP",
  "HAVELLS",
  "ICICIPRULI",
  "IGL",
  "INDIGO",
  "IOC",
  "IRCTC",
  "JINDALSTEL",
  "LUPIN",
  "MARICO",
  "MUTHOOTFIN",
  "NMDC",
  "PIDILITIND",
  "PNB",
  "RECLTD",
  "SAIL",
  "SHREECEM",
  "SIEMENS",
  "SRF",
  "TORNTPHARM",
  "TVSMOTOR",
  "VEDL",
  "YESBANK",
];
export const NIFTY_SMALLCAP_100 = [
  "AARTIDRUGS",
  "AFFLE",
  "AMARAJABAT",
  "ANURAS",
  "APLAPOLLO",
  "AVANTIFEED",
  "BASF",
  "BBTC",
  "BIRLACORPN",
  "BSOFT",
  "CAMS",
  "CARBORUNIV",
  "CENTURYPLY",
  "CHEMPLASTS",
  "CLEAN",
  "CYIENT",
  "DCMSHRIRAM",
  "EIDPARRY",
  "FINEORG",
  "GESHIP",
  "GSPL",
  "HEG",
  "HFCL",
  "IEX",
  "INDIAMART",
  "JBCHEPHARM",
  "JSL",
  "KAJARIACER",
  "KPITTECH",
  "LAURUSLABS",
  "LAXMIMACH",
  "MAHLOG",
  "METROPOLIS",
  "NATCOPHARM",
  "NESCO",
  "NIITLTD",
  "NOCIL",
  "PVRINOX",
  "RADICO",
  "RAJESHEXPO",
  "RALLIS",
  "ROUTE",
  "SPANDANA",
  "STAR",
  "SUBEX",
  "SUPRAJIT",
  "TANLA",
  "TEJASNET",
  "TRITURBINE",
  "UCOBANK",
  "VGUARD",
  "VINATIORGA",
  "WELCORP",
  "ZENSARTECH",
];
export const BANK_NIFTY = [
  "AUBANK",
  "AXISBANK",
  "BANDHANBNK",
  "BANKBARODA",
  "CANBK",
  "FEDERALBNK",
  "HDFCBANK",
  "ICICIBANK",
  "IDFCFIRSTB",
  "INDUSINDBK",
  "KOTAKBANK",
  "PNB",
  "SBIN",
  "YESBANK",
];
export const NIFTY_MIDCAP = [
  "ABBOTINDIA",
  "ADANIPOWER",
  "ALKEM",
  "APLAPOLLO",
  "ASHOKLEY",
  "ASTRAL",
  "AUROPHARMA",
  "BALKRISIND",
  "BERGEPAINT",
  "BHARATFORG",
  "BIOCON",
  "CUMMINSIND",
  "DALBHARAT",
  "DEEPAKNTR",
  "DIVISLAB",
  "DIXON",
  "ESCORTS",
  "GMRINFRA",
  "GODREJPROP",
  "GUJGASLTD",
  "HAVELLS",
  "HINDPETRO",
  "ICICIPRULI",
  "INDHOTEL",
  "INDIGO",
  "INDUSTOWER",
  "IPCALAB",
  "JUBLFOOD",
  "L&TFH",
  "LICHSGFIN",
  "LODHA",
  "LTTS",
  "M&MFIN",
  "MANAPPURAM",
  "MUTHOOTFIN",
  "NMDC",
  "OIL",
  "PAGEIND",
  "PEL",
  "PIIND",
  "POLYCAB",
  "PVRINOX",
  "SAIL",
  "SHREECEM",
  "SRF",
  "SUNTV",
  "TATACHEM",
  "TATACOMM",
  "TATAPOWER",
  "TORNTPHARM",
  "TVSMOTOR",
  "UBL",
  "UNIONBANK",
  "VOLTAS",
  "ZEEL",
  "ZYDUSLIFE",
  "ACC",
  "ADANIGREEN",
  "ADANITRANS",
  "AMBUJACEM",
  "APOLLOHOSP",
  "AUROPHARMA",
  "BANKINDIA",
  "BEL",
  "CANFINHOME",
  "CHOLAFIN",
  "COFORGE",
  "CONCOR",
  "CROMPTON",
  "GODREJCP",
  "HAL",
  "HINDZINC",
  "IDBI",
  "INDIAMART",
  "JSWENERGY",
  "LUPIN",
  "MRF",
  "NATIONALUM",
  "NAVINFLUOR",
  "PETRONET",
  "RECLTD",
  "RBLBANK",
  "SYNGENE",
  "THERMAX",
  "TRENT",
  "UNIONBANK",
  "WHIRLPOOL",
  "YESBANK",
  "ZENSARTECH",
  "HEROMOTOCO",
  "TORNTPOWER",
  "GLENMARK",
  "MPHASIS",
  "PFIZER",
  "RAJESHEXPO",
  "SANOFI",
  "SUPREMEIND",
  "TATAELXSI",
  "THERMAX",
  "TRIDENT",
  "VGUARD",
  "VINATIORGA",
];

// const socket = io("http://localhost:8000", {
//   transports: ["websocket"],
// });
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const SecurityMasterProvider = ({ children }) => {
  const [ticks, setTicks] = useState({});
  const [error, setError] = useState("");

  const loadNifty50 = async () => {
    // const res = await axios.get("http://localhost:8000/api/security-ids", {
    const res = await axios.get(`${BASE_URL}/api/security-ids`, {
      params: {
        symbols: NIFTY_50.join(","), // ✅ IMPORTANT
      },
    });
    return res.data;
  };
  const loadNifty100 = async () => {
    const res = await axios.get(`${BASE_URL}/api/security-ids`, {
      params: {
        symbols: NIFTY_100.join(","), // ✅ IMPORTANT
      },
    });
    return res.data;
  };
  const loadNiftySmallCap = async () => {
    const res = await axios.get(`${BASE_URL}/api/security-ids`, {
      params: {
        symbols: NIFTY_SMALLCAP_100.join(","), // ✅ IMPORTANT
      },
    });
    return res.data;
  };
  const loadNiftyBank = async () => {
    const res = await axios.get(`${BASE_URL}/api/security-ids`, {
      params: {
        symbols: BANK_NIFTY.join(","), // ✅ IMPORTANT
      },
    });
    return res.data;
  };
  const loadNiftyMidCap = async () => {
    const res = await axios.get(`${BASE_URL}/api/security-ids`, {
      params: {
        symbols: NIFTY_MIDCAP.join(","), // ✅ IMPORTANT
      },
    });
    return res.data;
  };
  const getSecurityIds = async (symbols = []) => {
    if (!symbols || !symbols.length) return [];

    try {
      const res = await axios.get(`${BASE_URL}/api/security-ids`, {
        params: {
          symbols: Array.isArray(symbols) ? symbols.join(",") : symbols,
        },
      });

      return res.data; // [{symbol, security_id}]
    } catch (e) {
      console.error("Security ID fetch failed", e.message);
      setError(e.message);
      return [];
    }
  };

  // const startLiveMarketFeed = (instruments) => {
  //   console.log("🚀 Emitting start-market-feed");
  //   socket.emit("start-market-feed", instruments);
  // };

  // const subscribeToTicks = (cb) => {
  //   socket.on("tick", cb);
  //   return () => socket.off("tick", cb);
  // };

  return (
    <SecurityMasterContext.Provider
      value={{
        ticks,
        loadNifty50,
        // startLiveMarketFeed,
        // subscribeToTicks,
        setTicks,
        loadNifty100,
        loadNiftySmallCap,
        loadNiftyBank,
        loadNiftyMidCap,
        getSecurityIds,
        error,
      }}
    >
      {children}
    </SecurityMasterContext.Provider>
  );
};

export const useSecurityMaster = () => useContext(SecurityMasterContext);

// // // New Code
// import { createContext, useContext, useState, useEffect } from "react";
// import axios from "axios";
// import { io } from "socket.io-client";

// const SecurityMasterContext = createContext();
// const BASE_URL = "http://localhost:8000";

// const socket = io(BASE_URL, {
//   transports: ["websocket"],
// });
// const NIFTY_50 = [
//   "ADANIENT",
//   "ADANIPORTS",
//   "APOLLOHOSP",
//   "ASIANPAINT",
//   "AXISBANK",
//   "BAJAJ-AUTO",
//   "BAJFINANCE",
//   "BAJAJFINSV",
//   "BHARTIARTL",
//   "BPCL",
//   "BRITANNIA",
//   "CIPLA",
//   "COALINDIA",
//   "DIVISLAB",
//   "DRREDDY",
//   "EICHERMOT",
//   "GRASIM",
//   "HCLTECH",
//   "HDFCBANK",
//   "HDFCLIFE",
//   "HEROMOTOCO",
//   "HINDALCO",
//   "HINDUNILVR",
//   "ICICIBANK",
//   "INDUSINDBK",
//   "INFY",
//   "ITC",
//   "JSWSTEEL",
//   "KOTAKBANK",
//   "LT",
//   "LTIM",
//   "M&M",
//   "MARUTI",
//   "NESTLEIND",
//   "NTPC",
//   "ONGC",
//   "POWERGRID",
//   "RELIANCE",
//   "SBILIFE",
//   "SBIN",
//   "SUNPHARMA",
//   "TATACONSUM",
//   "TATAMOTORS",
//   "TATASTEEL",
//   "TCS",
//   "TECHM",
//   "TITAN",
//   "ULTRACEMCO",
//   "UPL",
//   "WIPRO",
// ];
// const NIFTY_100 = [
//   "ADANIENT",
//   "ADANIPORTS",
//   "APOLLOHOSP",
//   "ASIANPAINT",
//   "AXISBANK",
//   "BAJAJ-AUTO",
//   "BAJFINANCE",
//   "BAJAJFINSV",
//   "BHARTIARTL",
//   "BPCL",
//   "BRITANNIA",
//   "CIPLA",
//   "COALINDIA",
//   "DIVISLAB",
//   "DRREDDY",
//   "EICHERMOT",
//   "GRASIM",
//   "HCLTECH",
//   "HDFCBANK",
//   "HDFCLIFE",
//   "HEROMOTOCO",
//   "HINDALCO",
//   "HINDUNILVR",
//   "ICICIBANK",
//   "INDUSINDBK",
//   "INFY",
//   "ITC",
//   "JSWSTEEL",
//   "KOTAKBANK",
//   "LT",
//   "LTIM",
//   "M&M",
//   "MARUTI",
//   "NESTLEIND",
//   "NTPC",
//   "ONGC",
//   "POWERGRID",
//   "RELIANCE",
//   "SBILIFE",
//   "SBIN",
//   "SUNPHARMA",
//   "TATACONSUM",
//   "TATAMOTORS",
//   "TATASTEEL",
//   "TCS",
//   "TECHM",
//   "TITAN",
//   "ULTRACEMCO",
//   "UPL",
//   "WIPRO",

//   "ABB",
//   "ADANIGREEN",
//   "ADANITRANS",
//   "AMBUJACEM",
//   "AUROPHARMA",
//   "BANDHANBNK",
//   "BANKBARODA",
//   "BERGEPAINT",
//   "BIOCON",
//   "BOSCHLTD",
//   "CANBK",
//   "CHOLAFIN",
//   "COLPAL",
//   "CONCOR",
//   "DABUR",
//   "DLF",
//   "GAIL",
//   "GODREJCP",
//   "HAVELLS",
//   "ICICIPRULI",
//   "IGL",
//   "INDIGO",
//   "IOC",
//   "IRCTC",
//   "JINDALSTEL",
//   "LUPIN",
//   "MARICO",
//   "MUTHOOTFIN",
//   "NMDC",
//   "PIDILITIND",
//   "PNB",
//   "RECLTD",
//   "SAIL",
//   "SHREECEM",
//   "SIEMENS",
//   "SRF",
//   "TORNTPHARM",
//   "TVSMOTOR",
//   "VEDL",
//   "YESBANK",
// ];

// // export const SecurityMasterProvider = ({ children }) => {
// //   const NIFTY_50 = [
// //     "ADANIENT",
// //     "ADANIPORTS",
// //     "APOLLOHOSP",
// //     "ASIANPAINT",
// //     "AXISBANK",
// //     "BAJAJ-AUTO",
// //     "BAJFINANCE",
// //     "BAJAJFINSV",
// //     "BHARTIARTL",
// //     "BPCL",
// //     "BRITANNIA",
// //     "CIPLA",
// //     "COALINDIA",
// //     "DIVISLAB",
// //     "DRREDDY",
// //     "EICHERMOT",
// //     "GRASIM",
// //     "HCLTECH",
// //     "HDFCBANK",
// //     "HDFCLIFE",
// //     "HEROMOTOCO",
// //     "HINDALCO",
// //     "HINDUNILVR",
// //     "ICICIBANK",
// //     "INDUSINDBK",
// //     "INFY",
// //     "ITC",
// //     "JSWSTEEL",
// //     "KOTAKBANK",
// //     "LT",
// //     "LTIM",
// //     "M&M",
// //     "MARUTI",
// //     "NESTLEIND",
// //     "NTPC",
// //     "ONGC",
// //     "POWERGRID",
// //     "RELIANCE",
// //     "SBILIFE",
// //     "SBIN",
// //     "SUNPHARMA",
// //     "TATACONSUM",
// //     "TATAMOTORS",
// //     "TATASTEEL",
// //     "TCS",
// //     "TECHM",
// //     "TITAN",
// //     "ULTRACEMCO",
// //     "UPL",
// //     "WIPRO",
// //   ];
// //   const NIFTY_100 = [
// //     "ADANIENT",
// //     "ADANIPORTS",
// //     "APOLLOHOSP",
// //     "ASIANPAINT",
// //     "AXISBANK",
// //     "BAJAJ-AUTO",
// //     "BAJFINANCE",
// //     "BAJAJFINSV",
// //     "BHARTIARTL",
// //     "BPCL",
// //     "BRITANNIA",
// //     "CIPLA",
// //     "COALINDIA",
// //     "DIVISLAB",
// //     "DRREDDY",
// //     "EICHERMOT",
// //     "GRASIM",
// //     "HCLTECH",
// //     "HDFCBANK",
// //     "HDFCLIFE",
// //     "HEROMOTOCO",
// //     "HINDALCO",
// //     "HINDUNILVR",
// //     "ICICIBANK",
// //     "INDUSINDBK",
// //     "INFY",
// //     "ITC",
// //     "JSWSTEEL",
// //     "KOTAKBANK",
// //     "LT",
// //     "LTIM",
// //     "M&M",
// //     "MARUTI",
// //     "NESTLEIND",
// //     "NTPC",
// //     "ONGC",
// //     "POWERGRID",
// //     "RELIANCE",
// //     "SBILIFE",
// //     "SBIN",
// //     "SUNPHARMA",
// //     "TATACONSUM",
// //     "TATAMOTORS",
// //     "TATASTEEL",
// //     "TCS",
// //     "TECHM",
// //     "TITAN",
// //     "ULTRACEMCO",
// //     "UPL",
// //     "WIPRO",

// //     "ABB",
// //     "ADANIGREEN",
// //     "ADANITRANS",
// //     "AMBUJACEM",
// //     "AUROPHARMA",
// //     "BANDHANBNK",
// //     "BANKBARODA",
// //     "BERGEPAINT",
// //     "BIOCON",
// //     "BOSCHLTD",
// //     "CANBK",
// //     "CHOLAFIN",
// //     "COLPAL",
// //     "CONCOR",
// //     "DABUR",
// //     "DLF",
// //     "GAIL",
// //     "GODREJCP",
// //     "HAVELLS",
// //     "ICICIPRULI",
// //     "IGL",
// //     "INDIGO",
// //     "IOC",
// //     "IRCTC",
// //     "JINDALSTEL",
// //     "LUPIN",
// //     "MARICO",
// //     "MUTHOOTFIN",
// //     "NMDC",
// //     "PIDILITIND",
// //     "PNB",
// //     "RECLTD",
// //     "SAIL",
// //     "SHREECEM",
// //     "SIEMENS",
// //     "SRF",
// //     "TORNTPHARM",
// //     "TVSMOTOR",
// //     "VEDL",
// //     "YESBANK",
// //   ];

// //   const [securityIds, setSecurityIds] = useState([]);

// //   // 🔹 REST: resolve symbols → security_id
// //   const loadNifty50 = async () => {
// //     const res = await axios.get(`${BASE_URL}/api/security-ids`, {
// //       params: { symbols: NIFTY_50.join(",") },
// //     });
// //     setSecurityIds(res.data);
// //     return res.data;
// //   };
// //   const loadNifty100 = async () => {
// //     const res = await axios.get(`${BASE_URL}/api/security-ids`, {
// //       params: { symbols: NIFTY_100.join(",") },
// //     });
// //     setSecurityIds(res.data);
// //     return res.data;
// //   };

// //   // 🔹 WS: start feed
// //   const startLiveMarketFeed = (instruments) => {
// //     socket.emit("start-market-feed", instruments);
// //   };

// //   // 🔹 WS: subscribe
// //   //   const subscribeToTicks = (cb) => {
// //   //     socket.on("tick", cb);
// //   //     return () => socket.off("tick", cb);
// //   //   };
// //   const subscribeToTicks = (callback) => {
// //     socket.on("tick", callback);

// //     // 🔴 return cleanup
// //     return () => {
// //       socket.off("tick", callback);
// //     };
// //   };

// //   return (
// //     <SecurityMasterContext.Provider
// //       value={{
// //         securityIds,
// //         loadNifty50,
// //         loadNifty100,
// //         startLiveMarketFeed,
// //         subscribeToTicks,
// //       }}
// //     >
// //       {children}
// //     </SecurityMasterContext.Provider>
// //   );
// // };
// // export const SecurityMasterProvider = ({ children }) => {
// //   const [securityIds, setSecurityIds] = useState([]);

// //   // 🔹 REST
// //   const loadNifty50 = async () => {
// //     const res = await axios.get(`${BASE_URL}/api/security-ids`, {
// //       params: { symbols: NIFTY_50.join(",") },
// //     });
// //     setSecurityIds(res.data);
// //     return res.data;
// //   };

// //   const loadNifty100 = async () => {
// //     const res = await axios.get(`${BASE_URL}/api/security-ids`, {
// //       params: { symbols: NIFTY_100.join(",") },
// //     });
// //     setSecurityIds(res.data);
// //     return res.data;
// //   };

// //   // 🔹 WS emit
// //   const startLiveMarketFeed = (instruments) => {
// //     socket.emit("start-market-feed", instruments);
// //   };

// //   // 🔹 WS subscribe
// //   const subscribeToTicks = (callback) => {
// //     socket.on("tick", callback);
// //     return () => socket.off("tick", callback);
// //   };

// //   return (
// //     <SecurityMasterContext.Provider
// //       value={{
// //         securityIds,
// //         loadNifty50,
// //         loadNifty100,
// //         startLiveMarketFeed,
// //         subscribeToTicks,
// //       }}
// //     >
// //       {children}
// //     </SecurityMasterContext.Provider>
// //   );
// // };
// export const SecurityMasterProvider = ({ children }) => {
//   const [securityIds, setSecurityIds] = useState([]);
//   const [isSocketReady, setIsSocketReady] = useState(false);

//   // ✅ Track socket connection
//   useEffect(() => {
//     socket.on("connect", () => {
//       console.log("✅ FRONTEND SOCKET CONNECTED:", socket.id);
//       setIsSocketReady(true);
//     });

//     socket.on("disconnect", () => {
//       console.log("❌ FRONTEND SOCKET DISCONNECTED");
//       setIsSocketReady(false);
//     });

//     return () => {
//       socket.off("connect");
//       socket.off("disconnect");
//     };
//   }, []);

//   // 🔹 REST: load symbols → security_id
//   const loadNifty50 = async () => {
//     const res = await axios.get(`${BASE_URL}/api/security-ids`, {
//       params: { symbols: NIFTY_50.join(",") },
//     });
//     setSecurityIds(res.data);
//     return res.data;
//   };

//   const loadNifty100 = async () => {
//     const res = await axios.get(`${BASE_URL}/api/security-ids`, {
//       params: { symbols: NIFTY_100.join(",") },
//     });
//     setSecurityIds(res.data);
//     return res.data;
//   };

//   // 🔹 WS emit (SAFE)
//   const startLiveMarketFeed = (instruments) => {
//     if (!isSocketReady) {
//       console.warn("⚠️ Socket not ready, delaying emit");
//       socket.once("connect", () => {
//         socket.emit("start-market-feed", instruments);
//       });
//       return;
//     }

//     console.log("📤 EMITTING start-market-feed", instruments.length);
//     socket.emit("start-market-feed", instruments);
//   };

//   // 🔹 WS subscribe
//   const subscribeToTicks = (callback) => {
//     socket.on("tick", callback);
//     return () => socket.off("tick", callback);
//   };

//   return (
//     <SecurityMasterContext.Provider
//       value={{
//         securityIds,
//         loadNifty50,
//         loadNifty100,
//         startLiveMarketFeed,
//         subscribeToTicks,
//       }}
//     >
//       {children}
//     </SecurityMasterContext.Provider>
//   );
// };
// export const useSecurityMaster = () => useContext(SecurityMasterContext);
// // SecurityMasterContext.js

//not workinh
// import { createContext, useContext, useState } from "react";
// import axios from "axios";
// import { io } from "socket.io-client";
// // import { socket } from "../socket";

// const Context = createContext();
// const BASE_URL = "http://localhost:8000";
// const socket = io(BASE_URL, {
//   transports: ["websocket"],
// });

// export const SecurityMasterProvider = ({ children }) => {
//   const [ticks, setTicks] = useState({});

//   const loadNifty = async (symbols) => {
//     const res = await axios.get(`${BASE_URL}/api/security-ids`, {
//       params: { symbols: symbols.join(",") },
//     });

//     socket.emit("START_FEED", { instruments: res.data });

//     socket.on("tick", (tick) => {
//       setTicks((p) => ({ ...p, [tick.SecurityId]: tick }));
//     });
//   };

//   return (
//     <Context.Provider value={{ ticks, loadNifty }}>{children}</Context.Provider>
//   );
// };

// export const useSecurityMaster = () => useContext(Context);
// import { createContext, useContext, useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { io } from "socket.io-client";

// const Context = createContext();
// const BASE_URL = "http://localhost:8000";

// export const SecurityMasterProvider = ({ children }) => {
//   const socketRef = useRef(null);
//   const [ticks, setTicks] = useState({});
//   const [connected, setConnected] = useState(false);

//   // 🔹 INIT SOCKET ONCE
//   useEffect(() => {
//     const socket = io(BASE_URL, {
//       transports: ["websocket"],
//     });

//     socketRef.current = socket;

//     socket.on("connect", () => {
//       console.log("✅ FRONTEND SOCKET CONNECTED");
//       setConnected(true);
//     });

//     socket.on("tick", (tick) => {
//       console.log("📈 TICK RECEIVED", tick);
//       setTicks((prev) => ({
//         ...prev,
//         [tick.SecurityId]: tick,
//       }));
//     });

//     socket.on("disconnect", () => {
//       console.log("❌ SOCKET DISCONNECTED");
//       setConnected(false);
//     });

//     return () => socket.disconnect();
//   }, []);

//   const loadNifty = async (symbols) => {
//     if (!connected) {
//       console.log("⏳ Socket not connected yet");
//       return;
//     }

//     const res = await axios.get(`${BASE_URL}/api/security-ids`, {
//       params: { symbols: symbols.join(",") },
//     });

//     console.log("📤 EMITTING START_FEED", res.data.length);

//     socketRef.current.emit("START_FEED", {
//       instruments: res.data,
//     });
//   };

//   return (
//     <Context.Provider value={{ ticks, loadNifty }}>{children}</Context.Provider>
//   );
// };

// export const useSecurityMaster = () => useContext(Context);
